"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ksys_app_template_1 = require("@kurtosys/ksys-app-template");

var QueryStore =
/** @class */
function () {
  function QueryStore() {}

  QueryStore.prototype.flattenProps = function (props, keysToFlatten) {
    var _this = this;

    if (props) {
      var response = (keysToFlatten || Object.keys(props || {})).reduce(function (acc, key) {
        var value = props[key];

        if (value && ksys_app_template_1.utils.typeChecks.isObject(value)) {
          if (value['queryOptionsType']) {
            acc[key] = _this.query(value);
          } else {
            acc[key] = _this.flattenProps(value);
          }
        } else {
          acc[key] = value;
        }

        return acc;
      }, {});
      return response;
    }
  };

  return QueryStore;
}();

exports.QueryStore = QueryStore;